import * as React from "react";
import { Link, withRouter } from "react-router-dom";
import { Col, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import nameof from "ts-nameof.macro";
import { RouteHelper } from "../IntranetRouter";
import { LicenciaContenidosEditTabs } from "../licenciasColegio/Edit";
import { EstadoEnvios, LineaPedidoTiendaListItem, PedidoTiendaDetailResult, TipoProductoTienda, Transportista } from "../models/dataModels";
import { IServiceForEdit } from "../utils/base/BaseServices";
import { NavigationHelper } from "../utils/base/Breadcrumb";
import { EditPageBase } from "../utils/base/EditPageBase";
import { GenericEditState } from "../utils/base/GenericEditState";
import { ModelValidation } from "../utils/base/ModelValidation";
import { I18n } from "../utils/I18n";
import { UserIcon, ViewIcon } from "../utils/Icons";
import { toCamelCase } from "../utils/ValuesFormatter";
import { PedidosTiendaService } from "../pedidosTienda/PedidosTiendaService";
import { VisualizadorDireccion } from "../pedidosTienda/VisualizadorDireccion";


interface PedidoColegioDetailResultEx extends PedidoTiendaDetailResult {
    envioShowDetails: number;
}

export class EditComp extends EditPageBase<PedidoColegioDetailResultEx> {

    protected _setPageTitleForNew(): string {
        return "N/A"
    }

    protected _setPageTitleForExisting(editModel: PedidoTiendaDetailResult): string {
        return `Ver pedido ${editModel.nombrePresupuesto || editModel.id}`;
    }

    protected _createApiService(): IServiceForEdit<PedidoColegioDetailResultEx> {
        return new PedidosTiendaService() as any as IServiceForEdit<PedidoColegioDetailResultEx>;
    }

    protected _generateForm(): JSX.Element {

        var envioSeleccionado = this.state.editModel.envioShowDetails == null
            ? null
            : (this.state.editModel.envios || []).find(e => e.id == this.state.editModel.envioShowDetails);

        return <React.Fragment>
            <Row>
                <Col md={8}>
                    <Row>
                        <Col md={4}>
                            <FormGroup>
                                <Label for={nameof(this.state.editModel.nombrePresupuesto)}>
                                    {I18n.Strings.pedidosColegio.nombre}
                                </Label>

                                <Input
                                    readOnly={true}
                                    id={nameof(this.state.editModel.nombrePresupuesto)}
                                    value={this.state.editModel.nombrePresupuesto || this.state.editModel.nombreCliente}
                                />
                            </FormGroup>
                        </Col>

                        <Col md={3}>
                            <FormGroup>
                                <Label for={nameof(this.state.editModel.fechaPresupuesto)}>
                                    {I18n.Strings.pedidosColegio.fechaPresupuesto}
                                </Label>

                                <Input
                                    readOnly={true}
                                    id={nameof(this.state.editModel.fechaPresupuesto)}
                                    value={I18n.Strings.formatDate(this.state.editModel.fechaPresupuesto || this.state.editModel.fechaPedido)}
                                />
                            </FormGroup>
                        </Col>

                        <Col md={3}>
                            <FormGroup>
                                <Label for={nameof(this.state.editModel.estadoPedidoScholarum)}>
                                    {I18n.Strings.pedidos.estado}
                                </Label>

                                <Input
                                    readOnly={true}
                                    value={I18n.Strings.getEnumText(`EstadoPedidoScholarum.${this.state.editModel.estadoPedidoScholarum}`)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <VisualizadorDireccion
                        label={I18n.Strings.pedidos.direccionEnvio}
                        direccion={this.state.editModel.direccionEnvio}
                    />
                </Col>
            </Row>

            {this._pintarTablaLineas(
                this.state.editModel.items.filter(i => i.tipoProducto == TipoProductoTienda.License || i.tipoProducto == TipoProductoTienda.Virtual),
                "Compras digitales")
            }

            {this._pintarTablaLineas(
                this.state.editModel.items.filter(i => i.tipoProducto == TipoProductoTienda.Simple),
                "Compras papel")
            }

            <div>
                <h4>Otras licencias asociadas</h4>
                {(this.state.editModel.licenciasExtra || []).length == 0 &&
                    <React.Fragment>
                        No hay elementos
                    </React.Fragment>
                }
                {(this.state.editModel.licenciasExtra || []).length != 0 &&
                    <div className="table-responsive">
                        <table className="table table-striped table-hover table-sm">
                            <thead>
                                <tr>
                                    <th>{I18n.Strings.pedidos.sku}</th>
                                    <th>{I18n.Strings.pedidos.producto}</th>
                                    <th>{I18n.Strings.pedidos.licencias}</th>
                                    <td>{toCamelCase(I18n.Strings.colegioUsuarios.usuarioAlumno)}</td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.editModel.licenciasExtra.map((item, index) => {

                                    return <tr key={index}>
                                        <td>{item.isbn}</td>
                                        <td>{item.contenido}</td>
                                        <td>
                                            <Link className="mr-2"
                                                to={RouteHelper.editLicenciasColegio(item.licenciaContenidoId, item.usuarioId, null, LicenciaContenidosEditTabs.Datos)}
                                            >
                                                {item.usuario}
                                            </Link>
                                        </td>
                                        <td>
                                            <a title="Ver usuario" href={RouteHelper.editUsuarioColegio(item.usuarioId)} target="_blank">
                                                <UserIcon />
                                            </a>
                                        </td>
                                    </tr>;
                                })}
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            <h3>{I18n.Strings.pedidosColegio.envios}</h3>
            {(this.state.editModel.envios || []).length == 0 &&
                <p className="lead text-center">No hay envíos</p>
            }
            {(this.state.editModel.envios || []).length > 0 &&
                <div className="table-responsive">
                    <table className="table table-striped table-hover table-sm">
                        <thead>
                            <tr>
                                <th>{I18n.Strings.pedidosColegio.nombre}</th>
                                <th>{I18n.Strings.pedidosColegio.transportista}</th>
                                <th>{I18n.Strings.pedidosColegio.numSeguimiento}</th>
                                <th>Fecha Expedición</th>
                                <th>Estado envío</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.editModel.envios.map((envio, index) => {

                                var urlSeguimiento = null as string;
                                if ((envio.referenciaSeguimiento || "").length != 0) {
                                    switch (envio.transportista) {
                                        case Transportista.CorreosExpress:
                                            urlSeguimiento = `https://s.correosexpress.com/search?s=${envio.referenciaSeguimiento}`;
                                            break;
                                        case Transportista.DHL:
                                            urlSeguimiento = `https://clientesparcel.dhl.es/LiveTracking/ModificarEnvio/${envio.referenciaSeguimiento}`;
                                            break;
                                    }
                                }

                                return <tr key={index}>
                                    <td>
                                        <span>{envio.documentoOrigen}</span>
                                        {' '}
                                        <ViewIcon
                                            onClick={() => {
                                                var state = this._cloneStateForSetState();
                                                state.editModel.envioShowDetails = envio.id;
                                                this.setState(state);
                                            }}
                                        />
                                    </td>
                                    <td>
                                        {I18n.Strings.getEnumText(`Transportista.${envio.transportista}`)}
                                    </td>
                                    <td>
                                        <>
                                            {(envio.referenciaSeguimiento || "").length == 0
                                                ? <span>N/A</span>
                                                : <a target="_blank" href={urlSeguimiento}>
                                                    {envio.referenciaSeguimiento}
                                                </a>}
                                        </>
                                    </td>
                                    <td>{I18n.Strings.formatDate(envio.fechaGeneracionEtiqueta)}</td>
                                    <td>{I18n.Strings.getEnumText(`EstadoEnvios.${EstadoEnvios[envio.estado]}`)}</td>
                                </tr>;
                            })}
                        </tbody>
                    </table>
                </div>
            }

            {envioSeleccionado && <Modal
                size="xl"
                isOpen={true}
                aria-hidden={false}
                backdrop={true}
                toggle={() => {
                    var state = this._cloneStateForSetState();
                    state.editModel.envioShowDetails = null;
                    this.setState(state);
                }}
            >
                <ModalHeader
                    close={<button className="btn-close" onClick={() => {
                        var state = this._cloneStateForSetState();
                        state.editModel.envioShowDetails = null;
                        this.setState(state);
                    }} ></button>}
                >
                    Detalle de envío - {envioSeleccionado.documentoOrigen}
                </ModalHeader>
                <ModalBody>

                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup>
                                <Label for={nameof(envioSeleccionado.destinatario)}>
                                    {I18n.Strings.pedidosColegio.destinatario}
                                </Label>
                                <Input
                                    id={nameof(envioSeleccionado.destinatario)}
                                    readOnly={true}
                                    value={envioSeleccionado.destinatario}
                                />
                            </FormGroup>
                        </div>

                        <div className="col-md-6">
                            <FormGroup>
                                <Label for={nameof(envioSeleccionado.compania)}>
                                    {I18n.Strings.pedidosColegio.compannia}
                                </Label>
                                <Input
                                    id={nameof(envioSeleccionado.compania)}
                                    readOnly={true}
                                    value={envioSeleccionado.compania}
                                />
                            </FormGroup>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup>
                                <Label for={nameof(envioSeleccionado.calle)}>
                                    {I18n.Strings.pedidosColegio.calle}
                                </Label>
                                <Input
                                    id={nameof(envioSeleccionado.calle)}
                                    readOnly={true}
                                    value={envioSeleccionado.calle}
                                />
                            </FormGroup>
                        </div>

                        <div className="col-md-6">
                            <FormGroup>
                                <Label for={nameof(envioSeleccionado.calle2)}>
                                    {I18n.Strings.pedidosColegio.calle2}
                                </Label>
                                <Input
                                    id={nameof(envioSeleccionado.calle2)}
                                    readOnly={true}
                                    value={envioSeleccionado.calle2}
                                />
                            </FormGroup>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4">
                            <FormGroup>
                                <Label for={nameof(envioSeleccionado.city)}>
                                    {I18n.Strings.pedidosColegio.ciudad}
                                </Label>
                                <Input
                                    id={nameof(envioSeleccionado.city)}
                                    readOnly={true}
                                    value={envioSeleccionado.city}
                                />
                            </FormGroup>
                        </div>

                        <div className="col-md-4">
                            <FormGroup>
                                <Label for={nameof(envioSeleccionado.zip)}>
                                    {I18n.Strings.pedidosColegio.codPostal}
                                </Label>
                                <Input
                                    id={nameof(envioSeleccionado.zip)}
                                    readOnly={true}
                                    value={envioSeleccionado.zip}
                                />
                            </FormGroup>
                        </div>
                        <div className="col-md-4">
                            <FormGroup>
                                <Label for={nameof(envioSeleccionado.countryId)}>
                                    {I18n.Strings.pedidosColegio.pais}
                                </Label>
                                <Input
                                    id={nameof(envioSeleccionado.countryId)}
                                    readOnly={true}
                                    value={envioSeleccionado.countryId == 68 ? "España" : (envioSeleccionado.countryId ?? "")}
                                />
                            </FormGroup>
                        </div>
                    </div>
                    <hr />
                    <div className="table-responsive">
                        <table className="table table-striped table-hover table-sm">
                            <thead>
                                <tr>
                                    <th>{I18n.Strings.pedidosColegio.isbn}</th>
                                    <th>{I18n.Strings.pedidosColegio.producto}</th>
                                    <th>{I18n.Strings.pedidosColegio.numUnidades}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(envioSeleccionado.lineas || []).map((linea, index) => {
                                    var itemEnPedido = this.state.editModel.items.find(p => p.sku == linea.isbn);

                                    return <tr key={linea.id}>
                                        <td>{itemEnPedido?.sku || linea.isbn}</td>
                                        <td>{itemEnPedido?.producto || linea.nombre}</td>
                                        <td>{linea.numUnidades}</td>
                                    </tr>;
                                })}
                            </tbody>
                        </table>
                    </div>
                </ModalBody>
            </Modal>}

        </React.Fragment>;
    }

    private _pintarTablaLineas(items: LineaPedidoTiendaListItem[], titulo: string): JSX.Element {

        return <>
            <h4 className="mt-4">{titulo}</h4>
            {items.length == 0 &&
                <React.Fragment>
                    No hay elementos
                </React.Fragment>
            }
            {items.length != 0 &&
                <div className="table-responsive">
                    <table className="table table-striped table-hover table-sm">
                        <thead>
                            <tr>
                                <th>{I18n.Strings.pedidos.sku}</th>
                                <th>{I18n.Strings.pedidos.producto}</th>
                                <th>{I18n.Strings.pedidos.tipo}</th>
                                <th>{I18n.Strings.pedidos.cantPedida}</th>
                                <th>{I18n.Strings.pedidos.cantDevuelta}</th>
                                <th>{I18n.Strings.pedidos.licencias}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, index) => {

                                return <tr key={index}>
                                    <td>{item.sku}</td>
                                    <td>{item.producto}</td>
                                    <td>{I18n.Strings.getEnumText(`TipoProductoTienda.${item.tipoProducto}`)}</td>
                                    <td>{item.cantidadPedida}</td>
                                    <td>{item.cantidadDevuelta}</td>
                                    <td>{this._pintarLicencias(item)}</td>
                                </tr>;
                            })}
                        </tbody>
                    </table>
                </div>
            }
        </>;
    }

    private _pintarLicencias(item: LineaPedidoTiendaListItem): JSX.Element {
        if ((item.licencias || "").length == 0) {
            return <span>N/A</span>;
        }
        else {
            let licencias = item.licencias.split(",");
            return <React.Fragment>
                {licencias.map((lic, index) => {

                    var partes = lic.split("#");

                    return <div key={index}>
                        <Link className="mr-2" to={RouteHelper.editLicenciasColegio(partes[0], null, null, LicenciaContenidosEditTabs.Datos)}>
                            {partes[1]}
                        </Link>
                        {' '}
                        <a title="Ver usuario" href={RouteHelper.editUsuarioColegio(partes[2])} target="_blank">
                            <UserIcon />
                        </a>
                    </div>;
                })}
            </React.Fragment>;
        }
    }

    protected updateBreadCrumb(model: PedidoTiendaDetailResult) {
        var items = [
            {
                text: I18n.Strings.pedidosColegio.title,
                link: RouteHelper.listPedidosColegio()
            },
            {
                text: this._setPageTitleForExisting(model),
                link: null
            }
        ];

        NavigationHelper.setBreadcrumbItems(items);
    }

    protected _getEditUrl(id: number): string {
        return RouteHelper.detallePedidoColegio(id);
    }

    protected _getListUrl(): string {
        return RouteHelper.listPedidosColegio();
    }

    protected _createStateForNew(): Promise<GenericEditState<PedidoColegioDetailResultEx>> {
        return null;
    }

    protected _validateModelLocal(): ModelValidation {
        let validation = new ModelValidation();

        return validation;
    }
}

export const Edit = withRouter(EditComp);
